<template>
  <div class="t-customer-view">
    <dass-header id="header-top" logoUrl="/home">
      <template v-slot:left-content>
        <router-link :to="`/home`" :title="$t('dass.pgInicial')">
          <div class="logo">
            <img
              :alt="`${brand.name} Logo`"
              :src="brandName == 'newbalance' && isMobile ? requireImage(`theme/${brand.folder}/logoMobile.png`) : requireImage(`theme/${brand.folder}/logo.png`)"
              :class="isMobile ? 'dass-logo-mobile' : ''"
            />
            <div v-if="!isMobile" class="version-container">
              <small> v: {{ version }} </small>
            </div>
          </div>
        </router-link>
      </template>
      <template v-slot:center-content>
        <div v-if="countSelected > 0"            
        @click="() => {        
          this.$route.name  == 'Home' ? 
          this.toggleSidebar(true) :
          this.$router.push('/home')     
        }" 
        class="dass-badge-icon-returns"
        >
          <dass-badge type="number" variant="secondary">
            <template #default> {{ countSelected }} </template>
          </dass-badge>          
          <span :class="`dass-icon-returns-${brandName}`"></span>
        </div>
        <dass-nav v-if="!isMobile">
          <dass-nav-item to="/home" id="link-to-home">
            {{ $t('dass.pgInicial') }}
          </dass-nav-item>        
          <dass-nav-item to="/protocolos" id="link-to-protocols">
            {{ $t('protocolos.protocolos') }}
          </dass-nav-item>
          <dass-nav-item to="/carteira" id="link-to-wallet">
            <span class="dass-wallet-container">
                {{ $t('dass.wallet') }}
                 <img v-if="totalBalance > 0" class="dass-sino-icon" :src="getIconNotification()" alt="Sino" >
            </span>           
          </dass-nav-item>
          <dass-nav-item  to="/login" id="btn-logout">
            {{ $t('dass.sair') }}
          </dass-nav-item>   
        </dass-nav>        
        <div v-if="isMobile"  class="flex center" :class="countSelected > 0 ? 'q-gutter-sm' : 'q-gutter-md'">    
          <div @click="$router.push('/home')" class="flex column center items-center clickable">
            <q-icon 
              :color="getColorBrand" 
              name="mdi-home-outline" 
              size="25px" 
            /> 
            <small :class="`${getIsActive('/home')}`" :style="`color: ${getColorBrand}; font-size: 2.5vw`"> {{ $t('dass.pgInicial') }}</small>
          </div>         
          <div @click="$router.push('/protocolos')" class="flex column center items-center clickable">
            <q-icon 
            :color="getColorBrand" 
            name="mdi-file-document-outline" 
            size="25px"
            />
            <small :class="`${getIsActive('/protocolos')}`" :style="`color: ${getColorBrand}; font-size: 2.5vw`"> {{ $t('protocolos.protocolos') }}</small>
          </div>
          <div @click="$router.push('/carteira')" class="flex column center items-center clickable">
            <q-icon 
              :color="getColorBrand"                
              name="mdi-credit-card-outline" 
              size="25px"                
            />
            <small :class="`${getIsActive('/carteira')}`" :style="`color: ${getColorBrand}; font-size: 2.5vw`"> {{ $t('dass.wallet') }}</small> 
          </div> 
        </div>
      </template>
      <template  v-slot:right-content>
        <div v-if="!isMobile">
          <language-selector></language-selector>
            <div class="version" v-if="isMobile">
              <small> v: {{ version }} </small>
            </div>
        </div>
        <dass-nav v-if="isMobile">          
          <dass-nav-item>
              <div>
                <language-selector></language-selector>
                  <div class="version" v-if="isMobile">
                    <small> v: {{ version }} </small>
                  </div>
              </div>
            </dass-nav-item>     
            <dass-nav-item  to="/login" id="btn-logout-mobile">
              {{ $t('dass.sair') }}
            </dass-nav-item>    
        </dass-nav> 
      </template>
    </dass-header>
    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import LanguageSelector from '../organisms/customer_view_template/LanguageSelector'
import packageJson from '../../../package'
import requireImage from '../../helpers/functions/requireImage'
import { useSelectedOrderFromLocalStorage } from '../../composables/useSelectedOrderFromLocalStorage'
import { getConfig } from '../../configs/service'

export default {
  name: 'customer-view-template',
  components: { LanguageSelector },
  emits: ['openSideBar'],   
  data: () => ({
    version: '',    
    brandName: ''  
  }), 
  setup() {
    const { getSelectedOrders } = useSelectedOrderFromLocalStorage()
    return {
      getSelectedOrders
    }    
  }, 
  computed: {
    ...mapGetters('brand', { brand: 'getBrand' }), 
    ...mapGetters('wallet', ['getTotalTransactions']),
    countSelected() {  
      return Object.keys(this.getSelectedOrders).length 
    },
    totalBalance() {
      return this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_CREDITADO - this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_DEBITADO || 0
    },    
    isMobile() {
      const width = this.$q.screen.width
      return width <= 700 ? true : false
    },
    getColorBrand() {
      return this.brandName == 'umbro' ? 'white' : this.brandName == 'fila' ? 'black' : 'red'
    }
  }, 
  methods: {
    ...mapActions('orders', ['toggleSidebar']),
    ...mapActions('generalSettings', ['loadGeneralSettings']),
    requireImage,    
    setActiveLink() {
      const links = document.querySelectorAll('.dass-link')      
      links.forEach(link => {
        const linkPath = link.href ? new URL(link.href).pathname : ''   
        if (linkPath === window.location.pathname || window.location.pathname === '/' && linkPath === '/home') {
          link.classList.add('active')          
        } else {
          link.classList.remove('active')          
        }
      })
    },
    getIconNotification() {
      return this.brandName == 'umbro' ? requireImage('icons8-notificação-white-30.png') : requireImage('icons8-notificação-black-24.png')
    },
    getIsActive(path) {
      const pathCurrent = window.location.pathname          
      return path === pathCurrent && this.brandName != 'newbalance' ? 'active-icons' : this.brandName == 'newbalance' && path === pathCurrent ? 'active-icons-newbalance' : this.brandName == 'newbalance' && pathCurrent == '/' && path == '/home' ? 'active-icons-newbalance' : pathCurrent === '/' && path === '/home' ? 'active-icons' : ''
    }
  },  
  created: async function () {  
    this.brandName = this.brand.name.replace(/\s/g, '').toLowerCase()
    const config = await getConfig()    
    const version = config?.VUE_APP_VERSION || process.env?.VUE_APP_VERSION || packageJson.version
    this.version = version?.match(/\d+\.\d+\.\d+/)?.[0] || version || ''
  },
  async mounted() {
    this.setActiveLink()
    this.loadGeneralSettings()

    const addRipple = (el) => {
    el.addEventListener("click", (e) => {
      const rect = el.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      el.style.setProperty("--ripple-x", x + "px")
      el.style.setProperty("--ripple-y", y + "px")
    })
  }

  this.$nextTick(() => {
    document
      .querySelectorAll(".clickable")
      .forEach((el) => addRipple(el))
  })
  },  
}
</script>

<style lang="scss">
.dass-header {
  background-color: var(--theme-white) !important;
  border-bottom: 2px solid var(--theme-gray_light);
  text-transform: uppercase;  
  .clickable {
    position: relative;
    overflow: hidden;
    transform: scale(1);
    transition: transform 0.2s ease-out;
  }
  .clickable:active {
    transform: scale(0.90);
  }  
  .clickable::after {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.15);
    width: 120px;
    height: 120px;
    border-radius: 50%;
    transform: scale(0);
    opacity: 0;
    pointer-events: none;
  }
  .clickable:active::after {
    transform: scale(1);
    opacity: 1;
    transition: 0.4s ease-out;
    top: var(--ripple-y, 50%);
    left: var(--ripple-x, 50%);
  }  
  .active-icons {
    font-weight: bold;
    border-bottom: 3px solid var(--theme-black); 
  }
  .active-icons-newbalance {
    font-weight: bold;
    border-bottom: 3px solid red; 
  }
  .dass-nav-wallet {
    position: relative;
  }
  .dass-wallet-container {
    position: relative;    
    white-space: nowrap;
  }
  .dass-sino-icon {
    position: absolute;
    top: -15px;
    right: -10px; 
    width: 20px;
    height: 20px; 
    animation: pulse 2s infinite;
  } 
  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  } 
  .logo {
    position: relative;
    > img {
      width: 100%;
      height: 100%;
    }
    .dass-logo-mobile {
      width: 45px !important;
      height: 40px !important;
    }
    
  }
  .dass-nav {    
    background-color: var(--theme-white);
    .dass-link {
      color: var(--theme-black);      
      transition: color 200ms;
      &:hover,
      &:active,
      &:focus {
        font-weight: bold;
        outline: none;        
        background-color: var(--theme-white);
      }
    }
  }
  .active {
    font-weight: bold;
    color: var(--theme-black) !important;      
    border-bottom: 4px solid var(--theme-black);   
  }
  details.dass-language-selector {
    &[open],
    &:focus,
    &:active,
    &:focus-within {
      outline: none !important;
      > summary {
        background-color: var(--theme-white) !important;
      }
    }
  }
  .dass-badge-icon-returns {
    cursor: pointer;
    position: relative;
    padding-top: 12px;
    &:hover { 
      scale: 1.1;
    }
    .dass-badge {
      margin-right: var(--space__0-5x);
      position: absolute;
      top: 0;
      left: -5px;    
               
    }
    .dass-badge--element {
      position: initial !important;
    }
    .texto {
      vertical-align: middle;
    }
    .dass-icon-returns-fila {
      display: inline-block; 
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("../../assets/files/icons8-devolver-compra-fila.png");
      width: 2.4rem;
      height: 2.4rem;
      margin-right: 0.5rem;
      @media(max-width: 700px) {
        width: 2rem;
        height: 2rem;
      }
    }
    .dass-icon-returns-umbro {
      display: inline-block;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("../../assets/files/icons8-devolver-compra-umbro.png");
      width: 2.4rem;
      height: 2.4rem;
      margin-right: 0.5rem;
      @media(max-width: 700px) {
        width: 2rem;
        height: 2rem;       
      }
    }
    .dass-icon-returns-newbalance {
      display: inline-block;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("../../assets/files/icons8-devolver-compra-newbalance.png");
      width: 2rem;
      height: 2rem;  
      margin-right: 0.5rem;   
    }
  }  
}
@media (min-width: 700px) {
  .dass-header {
    padding: 0 10vw;
  }
  .logo {
    max-width: 200px;
  }
  .version-container {
    color: var(--theme-gray);
    font-weight: bold;
    position: absolute;
    bottom: -10px;
    right: -35px;
  }
  .dass-nav .version {
    display: none;
  }
}
@media (max-width: 700px) {
  .dass-header {
    padding: 0.5rem 0.5rem !important;
  }
  .logo {
    display: flex;
    width: 60%;
  }
  .dass-nav {
    background: var(--theme-white) !important;
    .dass-nav--toggle-button {
      background: var(--theme-white) !important;
      color: var(--theme-black) !important;
      &:focus,
      &:active,
      &:focus-within {
        outline: none !important;
      }
    }
    .dass-nav--menu--item {
      text-align: center !important;
      justify-content: center !important;
    }
    .dass-nav--menu {      
      background: var(--theme-white) !important;
    }
  }
  .dass-nav .version {
    padding: var(--space);
    position: absolute;
    right: 0;
    bottom: 0;
    color: var(--theme-gray);
  }
  .version-container {
    display: none;
  }
}

.page-content {
  padding: var(--space);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-height: 100%;
  overflow-y: auto;
  > div {
    width: 80%;
    @media (max-width: 700px) {
      width: 100%;
    }
  }
}
.t-customer-view {
  .dass-nav--menu--item {
    display: flex !important;
    align-items: center;
  }
}

.theme-umbro .t-customer-view {
  .dass-header {
    padding: 0.5rem 10vw;
    background-color: var(--theme-color) !important;
    .logo {
      max-width: 70px !important;
    }
    @media (max-width: 700px) {
      padding: 0.5rem 0.5rem;
    }
    .dass-nav {
      background-color: var(--theme-color) !important;
      .dass-link {
          color: var(--theme-white) !important;  
      } 
      @media (max-width: 700px) {
        .dass-link {
          color: var(--theme-black) !important;  
        } 
      }
      li a {        
        &:hover {
          color: var(--theme-white) !important;          
          background-color: var(--theme-color) !important;
        }
      }
    }
    .active {
      font-weight: bold;
      color: var(--theme-white) !important;      
      border-bottom: 4px solid var(--theme-white) !important;   
    }
    .active-icons {
      font-weight: bold;
      border-bottom: 3px solid var(--theme-white) !important;  
    }
    
  }
}
</style>